// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__NiPyi","main-content":"Footer_main-content__btcl-"};